import React from 'react'

import { Container } from '../../../../../components'
import { BaseProps } from '../types'
import { Schedule } from '../../../../../models'
import { DateTime } from 'luxon'
import { Tooltip } from '@material-ui/core'
import { ReactComponent as ClipboardTickSBIcon } from '../../../../../assets/icons/clipboard-tick-bw.svg'
import { typographyStyle } from '../../../../../theme/typographyStyle'
interface Props extends BaseProps {
    project: Schedule
    onClick: (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        project: Schedule,
    ) => void
    currentTimezone: string
}

export const EventTypeProject = (props: Props) => {
    const { theme, project } = props

    const startDate = DateTime.fromISO(project.start_date).setZone(
        props.currentTimezone,
    )
    const endDate = DateTime.fromISO(project.end_date).setZone(
        props.currentTimezone,
    )

    // Get inspection name for tooltip
    const inspectionName = project.inspection_name ?? ''

    let timelineLabel = (
        <span
            style={{
                ...typographyStyle(theme.typography.body2),
                fontWeight: 300,
                marginRight: theme.spacing(2),
            }}
        >
            (Archived)
        </span>
    )

    if (project.active) {
        timelineLabel = (
            <Container>
                <Tooltip
                    title={`${startDate.toFormat('MM/dd/yyyy hh:mm a z')}`}
                >
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body2),
                            fontWeight: 700,
                            marginRight: theme.spacing(1),
                        }}
                    >
                        {startDate.toLocaleString(DateTime.DATE_MED)}
                    </span>
                </Tooltip>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body2),
                        fontWeight: 300,
                        marginRight: theme.spacing(1),
                    }}
                >
                    -
                </span>
                <Tooltip title={`${endDate.toFormat('MM/dd/yyyy hh:mm a z')}`}>
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body2),
                            fontWeight: 700,
                        }}
                    >
                        {endDate.toLocaleString(DateTime.DATE_MED)}
                    </span>
                </Tooltip>
            </Container>
        )
    }

    const isDraft = project.review_status === 'DRAFT'

    return (
        <Container
            style={{
                paddingLeft: theme.spacing(1),
                alignItems: 'center',
                flex: 1,
            }}
            onClick={(e) => props.onClick(e, project)}
        >
            {isDraft && (
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 700,
                        marginRight: theme.spacing(1),
                    }}
                >
                    DRAFT
                </span>
            )}
            <span
                style={{
                    ...typographyStyle(theme.typography.body1),
                    fontWeight: 700,
                    marginRight: theme.spacing(1),
                }}
            >
                {project.name}
            </span>
            {project.inspection && (
                <Tooltip title={inspectionName}>
                    <ClipboardTickSBIcon
                        style={{
                            width: 18,
                            height: 18,
                            marginRight: theme.spacing(2),
                        }}
                    />
                </Tooltip>
            )}
            {timelineLabel}
        </Container>
    )
}
